import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useBackgroundRefetch } from '@/components/AppBar/NetworkPopover/hooks/useNetworks';
import { mutationWithFeedback } from '@/utils/toast';
import { trpc } from '@/utils/trpc';
const useImportNetwork = () => {
  const $ = _c(7);
  const refetchInBackground = useBackgroundRefetch();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      suppressGlobalToast: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== refetchInBackground) {
    t1 = {
      meta: t0,
      onSettled: () => refetchInBackground()
    };
    $[1] = refetchInBackground;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    mutateAsync
  } = trpc.network.importNetwork.useMutation(t1);
  let t2;
  if ($[3] !== mutateAsync) {
    t2 = async json => {
      await mutationWithFeedback({
        mutation: mutateAsync(json),
        successText: "Imported network",
        errorText: "Failed to import network",
        loadingText: "Importing..."
      });
    };
    $[3] = mutateAsync;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const importNetwork = t2;
  let t3;
  if ($[5] !== importNetwork) {
    t3 = {
      importNetwork
    };
    $[5] = importNetwork;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default useImportNetwork;